// The business day: 5 AM to 5 AM Pakistan time (the backend's business_day.py).
// The floor works US hours (about 5 PM to 4 AM in Pakistan), so "Nov 2" means
// 5:00 AM Nov 2 up to 5:00 AM Nov 3 PKT, which is also midnight to midnight UTC.
// Date filters use it on every page; rows still show the real clock time.

const DAY_MS = 24 * 60 * 60 * 1000;

/** Hover hint for date pickers. */
export const BUSINESS_DAY_HINT = 'Days run 5 AM to 5 AM Pakistan time';

/** First moment of the business day picked as "YYYY-MM-DD" (a date input's value). */
export const businessDayStart = (ymd: string): Date => new Date(`${ymd.slice(0, 10)}T05:00:00+05:00`);

/** True when `when` falls between the From and To business days (either may be empty). */
export const inBusinessDays = (when: string | Date, from?: string, to?: string): boolean => {
  const t = new Date(when).getTime();
  if (from && t < businessDayStart(from).getTime()) return false;
  if (to && t >= businessDayStart(to).getTime() + DAY_MS) return false;
  return true;
};
